module.exports = __webpack_public_path__ + "img/sad_face.94bfec7d.png";